// extracted by mini-css-extract-plugin
export default {"ImageGalleryItem":"ImageGalleryItem_ImageGalleryItem__FDGiG","ImageGalleryItemImage":"ImageGalleryItem_ImageGalleryItemImage__gO0mJ"};